module.exports = __webpack_public_path__ + "static/img/22.8787a45.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/main/22.jpg
// module id = mlwE
// module chunks = 0